export default __webpack_public_path__ + "static/210528_夏日角色熱更預告_jp-a34c60a129120d5ea717d5bb3b1a7f2e.webp";